<template>
  <v-container class="VV_ShowDocument"
               fluid>
    <v-row v-if="document"
           style="height: 100%;">
      <v-col cols="12"
             md="9"
             style="height: 100%;">
        <codemirror-json :code="JSON.stringify(document, null, 2)"
                         :options="{lineNumbers: true, lineWrapping: true, mode: 'javascript', theme: 'monokai'}">
        </codemirror-json>
      </v-col>
      <v-col cols="12"
             md="3">
        <v-card>
          <v-card-title>
            Information
          </v-card-title>
          <v-card-subtitle>
            General Properties
          </v-card-subtitle>
          <v-card-text>
            <div class="d-flex">
              <div class="VV_PropertyName">
                Name
              </div>
              <div class="VV_PropertyValue">
                {{ document.name__v }}
              </div>
            </div>
            <div class="d-flex">
              <div class="VV_PropertyName">
                Title
              </div>
              <div class="VV_PropertyValue">
                {{ document.title__v }}
              </div>
            </div>
            <div class="d-flex">
              <div class="VV_PropertyName">
                Country
              </div>
              <div class="VV_PropertyValue">
                <div v-for="id in document.country__v">
                  {{ countryName(id) }}
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div class="VV_PropertyName">
                Product
              </div>
              <div class="VV_PropertyValue">
                <object-name v-for="prodID in document.product__v"
                             :key="prodID"
                             list="products"
                             :id="prodID">
                </object-name>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<style lang="scss">
.VV_ShowDocument {
  height: 90%;

  .vue-codemirror {
    height: 100%;
    position: relative;
  }

  .CodeMirror {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    height: auto;
  }
}
</style>
<script>
import {mapGetters} from 'vuex';
import {find} from 'lodash';
import pepperFlowService from '../../services/pepperFlowService';
import ObjectName from './components/ObjectName';
import CodemirrorJson from './components/CodeMirrorJson';

export default {
  components: {CodemirrorJson, ObjectName},
  data() {
    return {
      busy: false,
      document: null,
    }
  },
  computed: {
    ...mapGetters('pepperFlow', [
      'countries',
      'languages',
      'products',
    ]),
    connectionID() { // MLD-2626
      return this.$route.params.connectionID;
    },
    documentID() {
      return parseInt(this.$route.params.documentID);
    }
  },
  created() {
    this.$store.dispatch('veevaVault/initStore');
    this.fetchData(this.documentID, this.$route.query);
  },
  methods: {
    countryName(countryID) {
      const obj = find(this.countries, c => c.id === countryID);
      return obj ? obj.name__v : null;
    },
    productName(productID) {
      const obj = find(this.products, p => p.id === countryID);
      return obj ? obj.name__v : null;
    },
    fetchData(documentID, params) {
      this.busy = true;
      pepperFlowService.retrieveDocument(this.connectionID, documentID, params)
        .then(data => {
          this.document = data;
        })
        .finally(() => {
          this.busy = false;
        })
    },
  }
}
</script>
